import React, { Component, PropTypes } from 'react';
import { NitroHeading, NitroBadgeSelect } from 'nitro-components';

import { SingleSelect, NumberSpinnerFilter } from '../../../../../components/filter';

import styled from 'styled-components';
const FilterSection = styled.section`
  margin-bottom: 48px;
`;

const FrequencyText = styled.span`
  margin-left: 10px;
`;

class FrequencyRepeats extends Component {
  static getLabel = filter => {
    const repeat = filter.value.repeat;

    if (!repeat) {
      return '';
    }

    if (repeat === 'WEEKLY') {
      const weekdays = filter.value.weekdays.map(
        weekday => filter.weekdaysOptions.find(option => option.value === weekday).label
      );
      return `every week on ${weekdays}`;
    }

    const repeatText = filter.repeatsOptions.find(option => option.value === repeat).text;

    let occurrence = filter.value.occurrence;
    occurrence = occurrence === 1 ? '' : occurrence;
    const plural = filter.value.occurrence > 1 ? 's' : '';
    return `every ${occurrence} ${repeatText}${plural} `;
  };

  handleSelectChange = option => {
    this.props.action({
      value: {
        repeat: option.value,
        occurrence: this.props.filter.value.occurrence || 1,
        weekdays: this.props.filter.value.weekdays
      }
    });
  };

  handleSpinnerChange = number => {
    this.props.action({
      value: {
        repeat: this.props.filter.value.repeat,
        occurrence: number.value,
        weekdays: this.props.filter.value.weekdays
      }
    });
  };

  handleWeekdayChange = weekdays => {
    this.props.action({
      value: {
        repeat: this.props.filter.value.repeat,
        occurrence: this.props.filter.value.occurrence || 1,
        weekdays: weekdays.value
      }
    });
  };

  render() {
    const { filter } = this.props;
    const repeat = {
      mandatory: true,
      value: filter.value.repeat,
      options: filter.repeatsOptions
    };
    const occurrence = {
      value: filter.value.occurrence
    };

    const weekdays = filter.value.weekdays || [];

    const showSpinner = repeat.value && repeat.value !== 'WEEKLY';

    const showWeekdays = repeat.value === 'WEEKLY';

    const option = filter.repeatsOptions.find(option => filter.value.repeat === option.value);
    let text = '';

    if (option) {
      text = option.text;
    }

    if (occurrence.value > 1) {
      text += 's';
    }

    return (
      <section>
        <FilterSection>
          <SingleSelect action={this.handleSelectChange} filter={repeat} />
        </FilterSection>
        {showSpinner &&
          <FilterSection>
            <NitroHeading size="3" label="Every" margin="8" />
            <NumberSpinnerFilter id="frequencyEvery" action={this.handleSpinnerChange} filter={occurrence} />
            <FrequencyText>{text}</FrequencyText>
          </FilterSection>}
        {showWeekdays &&
          <FilterSection>
            <NitroHeading size="3" label="On" margin="8" />

            <NitroBadgeSelect value={weekdays} options={filter.weekdaysOptions} action={this.handleWeekdayChange} />

          </FilterSection>}
      </section>
    );
  }
}

FrequencyRepeats.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired,
  countries: PropTypes.array
};

export default FrequencyRepeats;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/components/frequency/FrequencyRepeats.js